import * as React from "react";
import { Trans } from "@lingui/react/macro";
import { AuthField } from "@app/ui/features/auth/AuthField";

export interface NicknameFieldProps {
  id?: string;
  value: string;
  onChange: (value: string) => void;
  /** 검증 실패 문구(이미 번역된 상태). react-hook-form 을 쓰는 화면이 넘겨준다. */
  error?: string;
  onBlur?: React.FocusEventHandler<HTMLInputElement>;
  required?: boolean;
  disabled?: boolean;
  className?: string;
}

const NicknameField = React.forwardRef<HTMLInputElement, NicknameFieldProps>(
  ({ id = "nickname", value, onChange, error, onBlur, required, disabled, className }, ref) => {
    return (
      <AuthField
        ref={ref}
        id={id}
        name="nickname"
        autoComplete="nickname"
        label={<Trans>닉네임</Trans>}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        error={error}
        required={required}
        disabled={disabled}
        className={className}
      />
    );
  }
);
NicknameField.displayName = "NicknameField";

export { NicknameField };
